import { createContext } from 'react';

const defaultContextValue = {
  keyLabel: '',
  keyValue: 0,
};
// Create a context for the tab state
const PianoTabContext = createContext(defaultContextValue);

export default PianoTabContext;